import moni from "../../assets/monistack.jpeg";
import crispi from "../../assets/crispi.jpeg";
import cartApp from "../../assets/cartApp.png";

export const PortfolioData = [
  {
    img: cartApp,
    title: "Mini Clothing Store",
    desc: "This is a simple shopping cart prototype ",
    link: "https://nkwo-shoppingcart.netlify.app/",
    github: "https://github.com/EmekaNkwo/shopping_cart_react_typescript",
  },
  {
    img: moni,
    title: "Monistack",
    desc: "A payment gateway Landing Page",
    link: "https://monistack.netlify.app/",
    github: "https://github.com/EmekaNkwo/monistack",
  },
  {
    img: crispi,
    title: "Cripsi Restuarant",
    desc: "Website for Modern Restuarant",
    link: "https://crispi.netlify.app/",
    github: "https://github.com/EmekaNkwo/crispi_restaurant",
  },
];
